module.exports = __webpack_public_path__ + "img/step5-mobile-en.396fe1c8.webp";